import AssignVehicleForm from '../components/AssignVehicleForm.vue';
import Vue from 'vue';
const assignVehicleFormHandler = (driver, vehicles, callback) => {
  const vm = new Vue({
    ...AssignVehicleForm,
    propsData: { driver, vehicles, callback },
  });
  vm.$mount();
  vm.$bvModal.show('assign-vehicle-form-modal');
};
export default assignVehicleFormHandler;
